// FEAT-036: Admin 사이드 트리뷰 키워드 검색 — 순수 헬퍼 모듈
// findMatchingNodes(list, keyword) — 키워드로 name 부분 매칭, id 배열 반환
// getAncestorIds(list, nodeId)   — parent 체인을 역추적하여 조상 id 배열 반환

/**
 * 키워드가 포함된 노드의 id 배열을 list 입력 순서대로 반환한다.
 * @param {Array} list  - 트리 노드 배열 (각 노드는 { id, name, ... } 형태)
 * @param {string} keyword - 검색어
 * @returns {string[]} 매칭된 노드 id 배열 (순서 보장)
 */
export const findMatchingNodes = (list, keyword) => {
    if (!keyword || keyword.trim() === '') return [];

    const q = keyword.trim().toLowerCase();
    return list
        .filter(node => node?.name && node.name.toLowerCase().includes(q))
        .map(node => node.id);
};

/**
 * nodeId의 조상 id 배열을 가까운 조상부터 순서대로 반환한다.
 * parent 체인을 따라 올라가며 parent가 falsy("", null, undefined)이면 종료.
 * visited Set으로 순환 참조를 방지한다.
 * @param {Array} list    - 트리 노드 배열
 * @param {string} nodeId - 시작 노드 id
 * @returns {string[]} 조상 id 배열 (가까운 조상 → 먼 조상 순, 자신 제외)
 */
export const getAncestorIds = (list, nodeId) => {
    const nodeMap = new Map(list.map(n => [n.id, n]));
    const startNode = nodeMap.get(nodeId);
    if (!startNode) return [];

    const ancestors = [];
    const visited = new Set([nodeId]);
    let current = startNode;

    while (true) {
        const parentId = current.parent;
        // parent가 falsy("", null, undefined)이면 종료
        if (!parentId) break;
        // 순환 참조 방지
        if (visited.has(parentId)) break;
        visited.add(parentId);

        const parentNode = nodeMap.get(parentId);
        // parent id가 list에 없으면 종료
        if (!parentNode) break;

        ancestors.push(parentId);
        current = parentNode;
    }

    return ancestors;
};
